import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./Ticket.css";
import "./menu3.css";

axios.defaults.withCredentials = true;

const CreateTickets = () => {
  const fileInputRef = useRef(null);
  const [helpTopic, setHelpTopic] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [severityLevel, setSeverityLevel] = useState("");
  const [sla, setSla] = useState("");
  const [userDetails, setUserDetails] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [customerAssets, setCustomerAssets] = useState([]);
  const [selectedAssetId, setSelectedAssetId] = useState("");

  const [formData, setFormData] = useState({
    email: "",
    fullName: "",
    position: "",
    phoneNumber: "",
    address: "",
    issueSummary: "",
    issueDetails: "",
    fileupload: [],
    files: [],
    severityLevel: "",
    sla: "",
    serialNumber: "",
    productName: "",
    customer_asset_id: "",
  });

  const [ticketPopup, setTicketPopup] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
    reloadAfterClose: false,
  });

  const showTicketPopup = ({
    type = "info",
    title = "",
    message = "",
    reloadAfterClose = false,
  }) => {
    setTicketPopup({
      show: true,
      type,
      title,
      message,
      reloadAfterClose,
    });
  };

  const closeTicketPopup = () => {
    const shouldReload = ticketPopup.reloadAfterClose;

    setTicketPopup({
      show: false,
      type: "",
      title: "",
      message: "",
      reloadAfterClose: false,
    });

    if (shouldReload) {
      window.location.reload();
    }
  };

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await axios.get("/customer/v2", {
          withCredentials: true,
        });
        setCustomerList(res.data.customers || []);
      } catch (error) {
        console.error("Error fetching customer list:", error);
      }
    };

    fetchCustomers();
  }, []);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const res = await axios.get("/customer", {
          withCredentials: true,
          validateStatus: (s) => s >= 200 && s < 500,
        });

        const user = res.status === 200 ? res.data?.user || null : null;
        setUserDetails(user);

        if (!user) {
          setFormData((prev) => ({
            ...prev,
            email: "",
            fullName: "",
            phoneNumber: "",
            position: "",
            company: "",
            address: "",
          }));
          return;
        }

        setFormData((prev) => ({
          ...prev,
          email: user.email || "",
          fullName: user.name || "",
          phoneNumber: user.phone || "",
          position: user.position || "",
          company: user.company_name || "",
        }));
      } catch (err) {
        console.error("Error fetching user details:", err);
        setUserDetails(null);
      }
    };

    fetchUserDetails();
  }, []);

  const fetchCustomerDetails = async (selectedId) => {
    try {
      const res = await axios.get(
        `/customer/${selectedId}`,
        {
          withCredentials: true,
          validateStatus: (s) => s >= 200 && s < 500,
        },
      );

      const user = res.data?.user || null;
      setUserDetails(user);

      if (!user) {
        setFormData((prev) => ({
          ...prev,
          email: "",
          fullName: "",
          phoneNumber: "",
          position: "",
          company: "",
          address: "",
        }));
        return;
      }

      setFormData((prev) => ({
        ...prev,
        email: user?.email || "",
        fullName: user?.name || "",
        phoneNumber: user?.phone || "",
        position: user?.position || "",
        company: user?.company_name || "",
        address: "",
      }));
    } catch (err) {
      console.error("Error fetching customer details:", err);
      setUserDetails(null);
    }
  };

  const fetchCustomerAssets = async (selectedId) => {
    try {
      const res = await axios.get(
        `/ticketcustomer/by-customer/${selectedId}`,
        {
          withCredentials: true,
        },
      );

      setCustomerAssets(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error fetching customer assets:", err);
      setCustomerAssets([]);
    }
  };

  const handleHelpTopicChange = (e) => {
    const selectedHelpTopic = e.target.value;
    setHelpTopic(selectedHelpTopic);

    setSeverityLevel(
      selectedHelpTopic === "Feedback and General Questions"
        ? "low"
        : selectedHelpTopic === "Report Hardware /Software System Down"
          ? "high"
          : "medium",
    );
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [id]: value }));
  };

  const handleFileChange2 = (event) => {
    const files = Array.from(event.target.files || []);

    if (files.length === 0) return;

    const currentFileKeys = new Set(
      selectedFiles.map(
        (file) => `${file.name}-${file.size}-${file.lastModified}`,
      ),
    );

    const newFiles = files.filter((file) => {
      const fileKey = `${file.name}-${file.size}-${file.lastModified}`;
      return !currentFileKeys.has(fileKey);
    });

    if (newFiles.length === 0) {
      showTicketPopup({
        type: "error",
        title: "เลือกไฟล์ซ้ำ",
        message: "ไฟล์นี้ถูกเลือกไว้แล้ว",
      });

      event.target.value = "";
      return;
    }

    if (selectedFiles.length + newFiles.length > 7) {
      showTicketPopup({
        type: "error",
        title: "อัปโหลดไฟล์เกินจำนวน",
        message: "คุณสามารถอัปโหลดไฟล์ได้ไม่เกิน 7 ไฟล์เท่านั้น",
      });

      event.target.value = "";
      return;
    }

    setSelectedFiles((prev) => [...prev, ...newFiles]);

    event.target.value = "";
  };
  const handleRemoveFile = (indexToRemove) => {
    setSelectedFiles((prev) =>
      prev.filter((_, index) => index !== indexToRemove),
    );

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleClearFiles = () => {
    setSelectedFiles([]);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const resetForm = () => {
    setFormData((prev) => ({
      ...prev,
      issueSummary: "",
      issueDetails: "",
      severityLevel: "",
      sla: "",
      fileupload: [],
      files: [],
      serialNumber: "",
      productName: "",
      customer_asset_id: "",
      address: "",
    }));
    setHelpTopic("");
    setSelectedFiles([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setCustomerAssets([]);
    setSelectedAssetId("");
    setSelectedCustomerId("");
    setUserDetails(null);
  };

  const submitForm = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    const ownerId = userDetails?.id || selectedCustomerId || "";

    if (!ownerId) {
      showTicketPopup({
        type: "error",
        title: "ไม่สามารถสร้าง Ticket ได้",
        message: "ไม่พบข้อมูลผู้ใช้สำหรับผูก Ticket (ownerId ว่าง)",
      });

      setIsSubmitting(false);
      return;
    }

    if (!formData.customer_asset_id) {
      showTicketPopup({
        type: "error",
        title: "กรุณาเลือกข้อมูล",
        message: "กรุณาเลือก Serial Number",
      });

      setIsSubmitting(false);
      return;
    }

    if (!helpTopic) {
      showTicketPopup({
        type: "error",
        title: "กรุณาเลือกข้อมูล",
        message: "กรุณาเลือก Help Topic",
      });

      setIsSubmitting(false);
      return;
    }

    if (!formData.issueSummary.trim()) {
      showTicketPopup({
        type: "error",
        title: "กรุณากรอกข้อมูล",
        message: "กรุณากรอก Issue Summary",
      });

      setIsSubmitting(false);
      return;
    }

    if (!formData.issueDetails.trim()) {
      showTicketPopup({
        type: "error",
        title: "กรุณากรอกข้อมูล",
        message: "กรุณากรอก Details",
      });

      setIsSubmitting(false);
      return;
    }

    const formDataObj = new FormData();

    formDataObj.append("id", ownerId);
    formDataObj.append("helpTopic", helpTopic);
    formDataObj.append("issueSummary", formData.issueSummary);
    formDataObj.append("severityLevel", severityLevel);
    formDataObj.append("sla", sla || formData.sla);
    formDataObj.append("issueDetails", formData.issueDetails);
    formDataObj.append("customer_asset_id", formData.customer_asset_id);
    formDataObj.append("serialNumber", formData.serialNumber);
    formDataObj.append("productName", formData.productName);

    selectedFiles.forEach((file) => formDataObj.append("attachedFiles", file));

    try {
      const res = await axios.post(
        "/ticketcustomer/admin",
        formDataObj,
        {
          withCredentials: true,
          headers: { "Content-Type": "multipart/form-data" },
          validateStatus: (s) => s >= 200 && s < 500,
        },
      );

      if (res.status >= 400) {
        const msg =
          res.data?.message ||
          res.data?.error ||
          JSON.stringify(res.data) ||
          "Request failed";

        showTicketPopup({
          type: "error",
          title: "สร้าง Ticket ไม่สำเร็จ",
          message: `${msg}`,
        });

        return;
      }

      resetForm();

      const fileInput = document.getElementById("fileupload");
      if (fileInput) fileInput.value = "";

      showTicketPopup({
        type: "success",
        title: "สร้าง Ticket สำเร็จ",
        message: `Ticket created successfully! Your ticket number is ${res.data?.ticketNumber}`,
        reloadAfterClose: true,
      });
    } catch (error) {
      showTicketPopup({
        type: "error",
        title: "เกิดข้อผิดพลาด",
        message: ` ${error?.message || "Unknown error"}`,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSeverityLevelsChange = (e) => {
    setSeverityLevel(e.target.value);
  };

  return (
    <>
      <div className="ticket-main-content">
          <div className="form-actions">
            <button
              onClick={submitForm}
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Processing..." : "Create Ticket"}
            </button>
        </div>
        <div className="ticket-form-container">
          <h2>Open a New Ticket</h2>
          <p>Please fill in the form below to open a new ticket.</p>
          <div className="form-group">
            <label>Select Customer Name:</label>
            <select
              value={selectedCustomerId}
              onChange={async (e) => {
                const selectedId = e.target.value;
                setSelectedCustomerId(selectedId);

                setSelectedAssetId("");
                setCustomerAssets([]);

                setFormData((prev) => ({
                  ...prev,
                  serialNumber: "",
                  productName: "",
                  customer_asset_id: "",
                  address: "",
                  sla: "",
                }));

                setSla("");

                if (selectedId) {
                  await fetchCustomerDetails(selectedId);
                  await fetchCustomerAssets(selectedId);
                } else {
                  setUserDetails(null);
                  setFormData((prev) => ({
                    ...prev,
                    email: "",
                    fullName: "",
                    phoneNumber: "",
                    position: "",
                    address: "",
                    serialNumber: "",
                    productName: "",
                    customer_asset_id: "",
                    sla: "",
                  }));

                  setSla("");
                }
              }}
            >
              <option value="">-- Select Customer --</option>
              {(customerList || []).map((customer) => (
                <option key={customer.id} value={customer.id}>
                  {customer.company_name} ({customer.name})
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Select Serial Number:</label>
            <select
              value={selectedAssetId}
              onChange={(e) => {
                const assetId = e.target.value;
                setSelectedAssetId(assetId);

                const selectedAsset = customerAssets.find(
                  (item) => String(item.id) === String(assetId),
                );

                if (!selectedAsset || Number(selectedAsset.is_expired) === 1) {
                  setFormData((prev) => ({
                    ...prev,
                    serialNumber: "",
                    productName: "",
                    customer_asset_id: "",
                    address: "",
                    sla: "",
                  }));

                  setSla("");
                  return;
                }

                setFormData((prev) => ({
                  ...prev,
                  serialNumber: selectedAsset.serial || "",
                  productName: selectedAsset.product || "",
                  customer_asset_id: selectedAsset.id || "",
                  address: selectedAsset.address || "",
                  sla: selectedAsset.current_sla || "",
                }));

                setSla(selectedAsset.current_sla || "");
              }}
              disabled={!selectedCustomerId}
            >
              <option value="">-- Select Serial Number --</option>

              {customerAssets.length === 0 ? (
                <option value="" disabled>
                  ยังไม่พบข้อมูล
                </option>
              ) : (
                customerAssets.map((asset) => (
                  <option
                    key={asset.id}
                    value={asset.id}
                    disabled={Number(asset.is_expired) === 1}
                  >
                    {asset.serial}
                    {Number(asset.is_expired) === 1 ? " (expire)" : ""}
                  </option>
                ))
              )}
            </select>
          </div>

          <div className="form-group">
            <label>Product:</label>
            <input
              type="text"
              id="productName"
              value={formData.productName}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>Email :</label>
            <input type="email" id="email" value={formData.email} readOnly />
          </div>

          <div className="form-group">
            <label>Full Name:</label>
            <input
              type="text"
              id="fullName"
              value={formData.fullName}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>Phone Number:</label>
            <input
              type="text"
              id="phoneNumber"
              value={formData.phoneNumber}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>Address:</label>
            <input
              type="text"
              id="address"
              value={formData.address || ""}
              readOnly
            />
          </div>

          <div className="form-group">
            <label className="ticket-field-label">
              Help Topic
              <span className="ticket-required-star">*</span>
            </label>
            <select
              id="help-topic"
              value={helpTopic}
              onChange={handleHelpTopicChange}
              className="help-topic-select"
            >
              <option value="">Select a Help Topic</option>
              <option value="Feedback and General Questions">
                Feedback and General Questions
              </option>
              <option value="Report Hardware / Software Performamce Issue">
                Report Hardware / Software Performance Issue
              </option>
              <option value="Report Hardware /Software System Down">
                Report Hardware / Software System Down
              </option>
            </select>
          </div>

          {helpTopic && (
            <>
              <div className="form-group">
                <label>Severity Levels:</label>
                <select
                  id="Severity-Levels"
                  value={severityLevel}
                  onChange={handleSeverityLevelsChange}
                  className="help-topic-select no-arrow"
                  disabled
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                </select>
              </div>

              <div className="form-group">
                <label>SLA:</label>
                <input
                  type="text"
                  id="Sla"
                  value={sla || formData.sla || ""}
                  readOnly
                />
              </div>

              <div className="form-group">
                <label className="ticket-field-label">
                  Issue Summary
                  <span className="ticket-required-star">*</span>
                </label>
                <input
                  type="text"
                  id="issueSummary"
                  name="issueSummary"
                  value={formData.issueSummary}
                  onChange={handleInputChange}
                  placeholder="Brief summary of your issue"
                  required
                />
              </div>

              <div className="form-group">
                <label className="ticket-field-label">
                  Details
                  <span className="ticket-required-star">*</span>
                </label>
                <textarea
                  id="issueDetails"
                  name="issueDetails"
                  value={formData.issueDetails}
                  onChange={handleInputChange}
                  placeholder="Provide details about the issue"
                  required
                />
              </div>

              <div className="form-group">
                <label>Attach Files (ไม่บังคับ)</label>
                <input
                  ref={fileInputRef}
                  type="file"
                  id="fileupload"
                  multiple
                  onChange={handleFileChange2}
                />

                {selectedFiles.length > 0 ? (
                  <>
                    <ul className="selected-file-list">
                      {selectedFiles.map((file, index) => (
                        <li key={`${file.name}-${file.size}-${index}`}>
                          <span>
                            {file.name} ({(file.size / 1024 / 1024).toFixed(2)}{" "}
                            MB)
                          </span>

                          <button
                            type="button"
                            className="remove-file-button"
                            onClick={() => handleRemoveFile(index)}
                          >
                            ลบ
                          </button>
                        </li>
                      ))}
                    </ul>

                    <button
                      type="button"
                      className="clear-files-button"
                      onClick={handleClearFiles}
                    >
                      ลบไฟล์ทั้งหมด
                    </button>
                  </>
                ) : (
                  <p className="no-file-text">ยังไม่ได้เลือกไฟล์</p>
                )}
              </div>
            </>
          )}
        </div>

        {ticketPopup.show && (
          <div className="ticket-alert-popup-overlay">
            <div className="ticket-alert-popup-modal">
              <h3>{ticketPopup.title}</h3>

              <p>{ticketPopup.message}</p>

              <div className="ticket-alert-popup-actions">
                <button
                  type="button"
                  className={`ticket-alert-popup-btn ${
                    ticketPopup.type === "success" ? "success" : "error"
                  }`}
                  onClick={closeTicketPopup}
                >
                  ตกลง
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CreateTickets;
